<template>
  <DynamicModal
    :showModal="showModalProp"
    :persistent="false"
    @clickOutside="closeModal"
    title="Job Opening Info"
    maxWidth="800px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <SummaryTitle title="Client" v-if="jobOpeningInfo.client_Name.name"></SummaryTitle>
      <SummaryItem itemTitle="Client Name" v-if="jobOpeningInfo.client_Name.name">
        <template v-slot:content>
          {{ jobOpeningInfo.client_Name.name }}
        </template>
      </SummaryItem>
      <SummaryTitle
        title="Candidates"
        v-if="!!jobOpeningInfo.associated_Candidates &&
                  jobOpeningInfo.associated_Candidates.length > 1"
      >
      </SummaryTitle>
      <SummaryTitle
        title="Candidate"
        v-if="!!jobOpeningInfo.associated_Candidates &&
                  jobOpeningInfo.associated_Candidates.length === 1"
      >
      </SummaryTitle>
      <SummaryItem
        v-if="!!jobOpeningInfo.associated_Candidates &&
                  jobOpeningInfo.associated_Candidates.length > 0"
        v-for="(candidate, index) in jobOpeningInfo.associated_Candidates"
        :key="index"
        item-title="Candidate Name"
      >
        <template v-slot:content>
          {{ candidate.first_Name }} {{ candidate.last_Name }}
        </template>
      </SummaryItem>
      <SummaryTitle title="Position"></SummaryTitle>
      <SummaryItem itemTitle="Posting Title" v-if="!!jobOpeningInfo.posting_Title">
        <template v-slot:content>
          {{ jobOpeningInfo.posting_Title }}
        </template>
      </SummaryItem>
      <SummaryItem itemTitle="Job Type" v-if="jobOpeningInfo.job_Type">
        <template v-slot:content>
          {{ jobOpeningInfo.job_Type }}
        </template>
      </SummaryItem>
      <SummaryItem itemTitle="Salary" v-if="jobOpeningInfo.salary">
        <template v-slot:content>
          {{ jobOpeningInfo.salary }}
        </template>
      </SummaryItem>
      <SummaryItem itemTitle="Hourly Rate" v-if="jobOpeningInfo.hourly_Rate">
        <template v-slot:content>
          {{ jobOpeningInfo.hourly_Rate | currency }}
        </template>
      </SummaryItem>
      <SummaryItem itemTitle="Client Rate" v-if="jobOpeningInfo.client_Rate">
        <template v-slot:content>
          {{ jobOpeningInfo.client_Rate | currency }}
        </template>
      </SummaryItem>
      <SummaryItem itemTitle="Created By" v-if="jobOpeningInfo.created_By.name">
        <template v-slot:content>
          {{ jobOpeningInfo.created_By.name }}
        </template>
      </SummaryItem>
      <SummaryItem itemTitle="Account Manager" v-if="jobOpeningInfo.account_Manager.name">
        <template v-slot:content>
          {{ jobOpeningInfo.account_Manager.name }}
        </template>
      </SummaryItem>
      <SummaryItem itemTitle="Duration" v-if="jobOpeningInfo.duration">
        <template v-slot:content>
          {{ jobOpeningInfo.duration }}
        </template>
      </SummaryItem>
      <SummaryItem itemTitle="Duration Type" v-if="jobOpeningInfo.duration_Type">
        <template v-slot:content>
          {{ jobOpeningInfo.duration_Type }}
        </template>
      </SummaryItem>
    </v-container>
    <v-container fluid slot="buttons" class="mt-3 pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-12">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Close
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import { SummaryItem, SummaryTitle } from '@/components/shared/display'

export default {
  components: {
    SummaryItem,
    SummaryTitle,
    DynamicModal
  },
  props: [
    'jobOpeningInfo'
  ],
  data () {
    return {
      showModalProp: false
    }
  },
  methods: {
    showModal () {
      this.showModalProp = true
    },
    closeModal () {
      this.showModalProp = false
    }
  }
}
</script>

<style>
.dot-leader {
  /* Center the content */
  align-items: center;
  display: flex;
  justify-content: center;
}

.dot-leader__dots {
  /* Bottom border */
  border-bottom: 1px dotted #d1d5db;

  /* Take remaining width */
  flex: 1;

  /* Spacing */
  margin: 0 0.25rem;
}
</style>
